<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Pagination" pageTitle="Pagination" />
            <PaginationContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import PaginationContent from '../Pagination/PaginationContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'PaginationPage',
    components: {
        MainHeader,
        PageTitle,
        PaginationContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>